module.exports = __webpack_public_path__ + "img/LOGO_NEU_LISTEX.7474643e.svg";